<div *ngIf="!isPasswordChanged">
  <h1 class="harp-card-title">Change Password</h1>
  <p>
    Your password has expired or is about to expire. Please enter the fields
    below to change your password.
  </p>

  <form [formGroup]="changePasswordForm" (ngSubmit)="passwordExpCheck()">
    <harp-input [inputConfig]="oldPasswordInputConfig"></harp-input>
    <harp-input [inputConfig]="newPasswordInputConfig"></harp-input>
    <harp-input [inputConfig]="confirmNewPasswordInputConfig"></harp-input>

    <harp-password-strength
      [passwordToCheck]="newPasswordControl.value"
    ></harp-password-strength>

    <button
      class="btn btn-primary btn-lg"
      type="submit"
      [disabled]="changePasswordForm.invalid"
    >
      Change Password
    </button>
  </form>
</div>

<!-- Change Password Success Message-->
<div *ngIf="isPasswordChanged">
  <h1 class="harp-card-title">Success!</h1>
  <p>Your password has been successfully changed.</p>
  <a [routerLink]="['/login']" queryParamsHandling="merge">
    <strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
  >
</div>
